module.exports = __webpack_public_path__ + "img/img_throw_5@2x_v3.24e82059.png";